import React, { ChangeEvent, useState } from 'react';
import { TextArea } from '@cimpress/react-components';

function TextAreaExample() {
  const [text, setText] = useState('');

  const onInputChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  return <TextArea name="description" label="Description" value={text} onChange={e => onInputChange(e)} />;
}

export default TextAreaExample;
